import type { AllCountryCodes, ClubCountryCodes } from "@teamz/common";

import { clubCountryENNamesList, clubCountryFRNamesList, countryENNamesList, countryFRNamesList, formatCountryNameFromCountryCode } from "@teamz/common";
import { useTranslation } from "react-i18next";

type CountryCode = AllCountryCodes | ClubCountryCodes;

export function formatCountryName(countryCode: CountryCode | null | undefined, locale: Intl.LocalesArgument) {
  if (!countryCode) {
    return "";
  }

  return formatCountryNameFromCountryCode(countryCode.toUpperCase() as CountryCode, locale);
}

export function useTranslationUtils() {
  const { i18n } = useTranslation();

  // convert from "en-US" to "en"
  const countryCodeLocale = i18n.language.substring(0, 2).toLowerCase();

  function getCountryName(countryCode: CountryCode | null | undefined) {
    return formatCountryName(countryCode, countryCodeLocale);
  }

  function getFilteredCountriesList(search: string) {
    const list = countryCodeLocale === "fr" ? countryFRNamesList : countryENNamesList;
    return list.filter(({ name }) => (
      name?.toLowerCase().includes(search.toLowerCase())
    ));
  }

  function getFilteredClubCountriesList(search: string) {
    const list = countryCodeLocale === "fr" ? clubCountryENNamesList : clubCountryFRNamesList;
    return list.filter(({ name }) => (
      name?.toLowerCase().includes(search.toLowerCase())
    ));
  }

  return { getCountryName, getFilteredCountriesList, getFilteredClubCountriesList, countryCodeLocale };
}
